import Axios from "axios";
import { ApiBaseUrl, SupplierUserBaseUrl } from "../config/config";
import { ApiResultModel } from "../models/common.model";
import { GetSupplierUserInfoRequest, GetSupplierUserListResponse, SupplierUserRequest } from "../models/supplierUser.model";


export const CreateSupplierUser = (
  data: SupplierUserRequest
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SupplierUserBaseUrl + "/CreateSupplierUser",
    data
  ).then((result) => {
    return result.data.data; 
  });
};

export const EditSupplierUser = (
  data: SupplierUserRequest
): Promise<boolean> => {
  return Axios.post<ApiResultModel<boolean>>(
    ApiBaseUrl + SupplierUserBaseUrl + "/EditSupplierUser",
    data
  ).then((result) => {
    return result.data.data; 
  });
};

export const GetSupplierUserList = (): Promise<GetSupplierUserListResponse[]> => {
  return Axios.post<ApiResultModel<GetSupplierUserListResponse[]>>(
    ApiBaseUrl + SupplierUserBaseUrl + "/GetSupplierUserList",
  ).then((result) => {
    return result.data.data; 
  });
};

export const GetSupplierUserInfo = async(
  data: GetSupplierUserInfoRequest
): Promise<GetSupplierUserListResponse> => {
  return await  Axios.post<ApiResultModel<GetSupplierUserListResponse>>(
    ApiBaseUrl + SupplierUserBaseUrl + "/GetSupplierUserInfo",
    data
  ).then((result) => {
    return result.data.data; 
  });
};